// Actions
const ACTION_TYPES = {
  SET_PET_SHELTER_CONFIG: "web-app-magmic-core/packs/SET_PET_SHELTER_CONFIG"
}

export const setPetShelterConfig = (petShelterConfig) => ({
  type: ACTION_TYPES.SET_PET_SHELTER_CONFIG,
  petShelterConfig: petShelterConfig
});

const initialState = {petShelterConfig:[]};

// Reducers
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ACTION_TYPES.SET_PET_SHELTER_CONFIG:
      return {
        ...state, // spread operator to create a new copy of state
        petShelterConfig: action.petShelterConfig
      };
    default:
      return state; // returned during app initialization
  }
}


/*
"shelter": [
  {
      "$type": "Game.ShelterGachaLottery, Assembly-CSharp",
      "id": "gacha_farmer",
      "enable": true,
      "quantity": 1,
      "price": "95000000000000",
      "classifications": [
          0
      ],
      "specialties": [
          "R_Flour",
          "R_Strawberry"
      ],
      "probabilities": [
          {
              "rarity": 0,
              "percent": 60
          },
          {
              "rarity": 1,
              "percent": 35
          },
          {
              "rarity": 2,
              "percent": 5
          }
      ]
  },
  ...
  */